import React from 'react';

import Modal, { ModalProps } from '../Modal';
import DialogContentWrapper from './DialogContentWrapper';

export interface DialogProps<Data> extends ModalProps<Data> {
  color?: string;
}

/**
 * @since 1.4.0
 */
const Dialog = Object.assign(
  <Data, >({
    name,
    children,
    modalTitle,
    Icon,
    color,
    ...props
  }: DialogProps<Data>) => {
    if (typeof children === 'function') {
      return (
        <Modal<Data> name={name} align="center" {...props}>
          {(...args) => (
            <DialogContentWrapper
              Icon={Icon}
              modalTitle={modalTitle}
              color={color}
            >
              {children(...args)}
            </DialogContentWrapper>
          )}
        </Modal>
      );
    }

    return (
      <Modal name={name} align="center" {...props}>
        <DialogContentWrapper
          Icon={Icon}
          modalTitle={modalTitle}
          color={color}
        >
          {children}
        </DialogContentWrapper>
      </Modal>
    );
  },
  {
    Content: Modal.Content,
    Footer: Modal.Footer,
    publicProps: [...Modal.publicProps],
  },
);

export default Dialog;
